<template>
  <div class="md-card md-theme-default">
    <div class="md-card-header">
      <div class="md-title">{{title}}</div>
      <div class="md-subhead">
        {{subTitle}}
        <span
          v-if="duration"
          class="duration-badge">
          {{duration}}
        </span>
      </div>
    </div>
    <div class="md-card-content">
      <slot></slot>
    </div>
    <div class="md-card-actions md-alignment-right">
      <template v-if="actionButton1">
        <a
          :href="actionButton1.link"
          v-if="actionButton1.link"
          target="_blank">
          <md-button
            type="button"
            :class="{'md-raised': !actionButton1.disabled}"
            @click.stop="actionButton1.action"
            :disabled="actionButton1.disabled">
            <md-progress-spinner
              v-if="!actionButton1.action && !actionButton1.link"
              class="md-accent"
              md-diameter="20"
              md-stroke="2"
              md-mode="indeterminate" />
            {{actionButton1.text}}
          </md-button>
        </a>
        <md-button
          v-if="!actionButton1.link"
          type="button"
          :class="{'md-raised': !actionButton1.disabled}"
          @click.stop="actionButton1.action"
          :disabled="actionButton1.disabled">
          <md-progress-spinner
            v-if="!actionButton1.action && !actionButton1.link"
            class="md-accent"
            md-diameter="20"
            md-stroke="2"
            md-mode="indeterminate" />
          {{actionButton1.text}}
        </md-button>
      </template>
      <template v-if="actionButton2">
        <a
          v-if="actionButton2.link"
          :href="actionButton2.link"
          target="_blank">
          <md-button
            type="button"
            :class="{'md-raised': !actionButton2.disabled}"
            @click.stop="actionButton2.action"
            :disabled="actionButton2.disabled">
            <md-progress-spinner
              v-if="!actionButton2.action && !actionButton2.link"
              class="md-accent"
              md-diameter="20"
              md-stroke="2"
              md-mode="indeterminate" />
            {{actionButton2.text}}
          </md-button>
        </a>
        <md-button
          v-if="!actionButton2.link"
          type="button"
          :class="{'md-raised': !actionButton2.disabled}"
          @click.stop="actionButton2.action"
          :disabled="actionButton2.disabled">
          <md-progress-spinner
            v-if="!actionButton2.action && !actionButton2.link"
            class="md-accent"
            md-diameter="20"
            md-stroke="2"
            md-mode="indeterminate" />
          {{actionButton2.text}}
        </md-button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
      default: '',
    },
    duration: {
      type: String,
      required: false,
    },
    actionButton1: {
      type: Object,
      required: false,
      default: null,
    },
    actionButton2: {
      type: Object,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';
.md-card {
  &.md-theme-default {
    .md-title {
      font-size: 20px;
      line-height: 1.5;
    }
    .md-subhead {
      font-size: 12px;
      color: #c5cbd5;
    }
    .duration-badge {
      margin-left: 2px;
      padding: 2px 6px;
      border-radius: 2px;
      background-color: #677284;
      color: #FFF;
    }
  }
}

::v-deep .md-button-content {
  display: flex;
  .md-progress-spinner {
    margin-right: 10px;
  }
}
</style>
